export const messageCenterConfig = {
  // components display
  createNew: true,
  messageTypeSelect: true,
  threadSearch: true,
  latestRight: false,
  messageCount: false,
  messagesText: false,
  searchPlaceholder: 'Search messages',

  // threads click
  clickModal: false,
  hoverOptions: false,
  activeThread: true,

  // display extra options 
  pin: true,
  archive: true,

  // form 
  messageRecipient: true,
  messageSubject: true,
  messageDropdown: true,
  displayMessages: true,
  messageTextArea: true,
  messageUpload: true
}

// change const based on details
export const messageCenterLandingConfig = {
  // components display
  createNew: false,
  messageTypeSelect: false,
  threadSearch: false,
  latestRight: false,
  messageCount: true,
  messagesText: false,
  searchPlaceholder: 'Search',

  // threads click
  clickModal: true,
  hoverOptions: false,
  activeThread: false,

  // display extra options 
  pin: false,
  archive: false,

  // form 
  messageRecipient: false,
  messageSubject: false,
  messageDropdown: false,
  displayMessages: true,
  messageTextArea: true,
  messageUpload: true
}

// change const based on details
export const mcLeadDetailsConfig = {
  // components display
  createNew: false,
  messageTypeSelect: false,
  threadSearch: true,
  latestRight: true,
  messageCount: false,
  messagesText: false,
  searchPlaceholder: 'Search',

  // threads click
  clickModal: false,
  hoverOptions: true,
  activeThread: false,

  // display extra options 
  pin: false,
  archive: false,

  // form 
  messageRecipient: false,
  messageSubject: false,
  messageDropdown: false,
  displayMessages: true,
  messageTextArea: true,
  messageUpload: true,

  // api types
  apiType: 'client'
}
